<template>
  <GenericLayout :title="$t('RESET_PASS.TITLE')" class="fill-height">
    <v-row no-gutters class="fill-height">
      <v-col
        md="8"
        cols="12"
        class="register-hero hidden-sm-and-down"
      ></v-col>

      <v-col
        md="4"
        cols="12"
        class="px-4 py-10"
      >
        <form>
          <p>
            <v-text-field
              v-model="user"
              type="text"
              name="username"
              :label="$t('RESET_PASS.USERNAME')"
              class="input-group--focused"
            ></v-text-field>
          </p>
          <p>
            <v-text-field
              v-model="year"
              type="text"
              name="year"
              :label="$t('RESET_PASS.YEAR')"
              class="input-group--focused"
            ></v-text-field>
          </p>
          <p>
            <v-text-field
              v-model="pass"
              :append-icon="show ? 'visibility_off' : 'visibility'"
              :rules="[rules.required, rules.min]"
              :type="show ? 'text' : 'password'"
              name="password"
              :label="$t('RESET_PASS.PASSWORD')"
              hint="At least 8 characters"
              class="input-group--focused"
              @click:append="show = !show"
            ></v-text-field>
          </p>

          <BaseLoader v-if="loading" />
          <BaseButton v-else @click="resetPass()">
            {{ $t('RESET_PASS.SUBMIT') }}
          </BaseButton>
        </form>
      </v-col>
    </v-row>
  </GenericLayout>
</template>

<style scoped>
.register-hero {
  background-image: url('../assets/img/promo-md-2x.png');
  background-size: cover;
}
</style>

<script>
import GenericLayout from '@/layouts/GenericLayout.vue';

export default {
  name: 'Login',
  components: {
    GenericLayout,
  },
  data: () => ({
    user: '',
    year: '',
    pass: '',
    show: false,
    rules: {
      required: (value) => !!value || 'Required.',
      min: (v) => v.length >= 8 || 'Min 8 characters',
    },
  }),
  computed: {
    loading() {
      return this.$store.state.session.isLoading;
    },
  },
  methods: {
    goHomeIfLogged() {
      const { session } = this.$store.state;
      if (session.isLogged && !session.isAnonymous) {
        this.$router.replace({ name: 'home' });
      }
    },
    resetPass() {
      this.$track('pass_reset', 'auth');
      this.$store.dispatch('session/resetPass', {
        name: this.user,
        year: this.year,
        pass: this.pass,
      }).then(() => {
        this.goHomeIfLogged();
      });
    },
  },
};
</script>
